import React, { useEffect, useState } from "react";
import { Box, Button } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { useAuth } from "../../../../auth/auth";
import { toast } from "react-toastify";
import { addWorkerTradesLabourReferenceForm, editWorkerTradesLabourReferenceForm, getWorkerTradesLabourReferenceForm } from "../../../../api/apiCall";
import { ReferenceFormModal } from "./ReferenceForm";
import { format } from "date-fns";
import ReferenceViewModal from "./ReferenceViewModal";

const Reference = ({profileInfo, getWorkerInfo}: any) => {
    const {state} = useAuth();
    const [referenceForms, setReferenceForms] = useState<any>([]);
    const [loading, ] = useState(false);
    const [isReferenceFormOpen, setIsReferenceFormOpen] = useState(false);
    const [editingReference, setEditingReference] = useState<any>(null);
    const [viewModalOpen, setViewModalOpen] = useState(false);
    const [viewingReference, setViewingReference] = useState<any>(null);

    const handleReferenceSubmit = async (data: any) => {
        if (editingReference) {
            const response: any = await editWorkerTradesLabourReferenceForm(state.user?.token, editingReference.id, {
                userId: profileInfo?.id,
                ...data,
                followedSiteRules: Boolean(data.followedSiteRules),
                reliableForSiteWork: Boolean(data.reliableForSiteWork),
                wouldReemploy: Boolean(data.wouldReemploy),
                timekeepingAndAttendance: Number(data.timekeepingAndAttendance),
                qualityOfWork: Number(data.qualityOfWork),
            })
            if(response?.success) {
                toast.success("Reference Form updated successfully");
                getReferenceForms();
            }
        } else {
            const response = await addWorkerTradesLabourReferenceForm(state.user?.token, {
                userId: profileInfo?.id,
                ...data,
                followedSiteRules: Boolean(data.followedSiteRules),
                reliableForSiteWork: Boolean(data.reliableForSiteWork),
                wouldReemploy: Boolean(data.wouldReemploy),
                timekeepingAndAttendance: Number(data.timekeepingAndAttendance),
                qualityOfWork: Number(data.qualityOfWork),
            });
            if (response) toast.success("Reference added");
        }
        setIsReferenceFormOpen(false);
        setEditingReference(null);
        getWorkerInfo();
        getReferenceForms();
    };

    const getReferenceForms = async () => {
        const response = await getWorkerTradesLabourReferenceForm(state.user?.token, profileInfo?.id);
        if(response) {
            setReferenceForms(response.data);
        }
    }

    useEffect(() => {
        getReferenceForms();
    }, []);

    const onboardingFormsColumns: any = [
        {
            field: "candidateName",
            headerName: "Candidate Name",
            flex: 1,
        },
        {
            field: "companyWorkedFor",
            headerName: "Company Worked For",
            headerAlign: 'center',
            align: 'center',
            flex: 1,
        },
        {
            field: "refereeName",
            headerName: "Referee Name",
            headerAlign: 'center',
            align: 'center',
            flex: 1,
        },
        {
            field: "refereePosition",
            headerName: "Referee Position",
            headerAlign: 'center',
            align: 'center',
            flex: 1,
        },
        {
            field: "completedByUserFullName",
            headerName: "Completed By",
            headerAlign: 'center',
            align: 'center',
            flex: 1,
        },
        {
            field: "completionDate",
            headerName: "Completion Date",
            headerAlign: 'center',
            align: 'center',
            flex: 1,
            renderCell: (params: any) => (
                <div>
                    {params.row.completionDate
                        ? format(new Date(params.row.completionDate), 'dd/MM/yyyy')
                        : ''}
                </div>
            ),
        },
        {
            field: "actions",
            headerName: "Actions",
            headerAlign: 'center',
            align: 'center',
            flex: 1.5,
            renderCell: (params: any) => (
                <Box gap={1} justifyContent="center" width="100%">
                <Button
                    variant="contained"
                    size="small"
                    style={{ backgroundColor: '#1976d2', boxShadow: 'none', marginRight: '20px' }}
                    onClick={() => {
                        setViewingReference(params.row);
                        setViewModalOpen(true);
                    }}
                >
                    View
                </Button>
                <Button
                    variant="contained"
                    size="small"
                    style={{ backgroundColor: 'gray', boxShadow: 'none' }}
                    onClick={() => {
                        setEditingReference(params.row);
                        setIsReferenceFormOpen(true);
                    }}
                >
                    Edit
                </Button>
                </Box>
            )
        }
    ];

    return (
        <Box bgcolor={"white"} padding={5}>
            <Box display="flex" justifyContent="space-between" mb={2}>
                <h2>Reference Forms</h2>
                <Button
                    variant="contained"
                    color="primary"
                    style={{boxShadow: "none", height: 40}}
                    onClick={() => {
                        setEditingReference(null);
                        setIsReferenceFormOpen(true);
                    }}
                >
                    Add Reference Form
                </Button>
            </Box>
            <Box>
                <DataGrid
                    rows={referenceForms || []}
                    columns={onboardingFormsColumns}
                    style={{height: 520}}
                    disableRowSelectionOnClick
                    sx={{
                        "& .MuiDataGrid-columnHeaderTitle": {
                            color: "#333",
                            fontWeight: "bold",
                            fontSize: 15.5,
                        }
                    }}
                />
            </Box>
            <ReferenceFormModal
                open={isReferenceFormOpen}
                onClose={() => { setIsReferenceFormOpen(false); setEditingReference(null); }}
                onSubmit={handleReferenceSubmit}
                initialData={editingReference}
                loading={loading}
                workerName={`${profileInfo?.name} ${profileInfo?.surname}`}
            />
            <ReferenceViewModal
                open={viewModalOpen}
                onClose={() => {
                  setViewModalOpen(false);
                  setViewingReference(null);
                }}
                data={viewingReference}
            />
        </Box>
    )
};

export default Reference;
